<template>
	<vs-popup
		:title="$t('choosePenaltyReason')"
		class="primary-popup set-ticket-failed"
		:active.sync="activeProp"
	>

		<div class="mt-3 px-2">
			<div class="mt-2">
				<label for="" class="vs-input--label">{{ $t('reason') }}</label>
				<v-select
					v-if="selectMounted"
					v-model="reason"
					ref="penaltySelect"
					:options="penaltyReasons"
					:reduce="item => item.id"
					:placeholder="$t('selectReason')"
					label="name"
					:clearable="false"
					:append-to-body="false"
					class="single-row-select w-full"
				/>
			</div>

			<vs-input
				:label="$t('order') + ' №'"
				v-model="orderId"
				class="amount-input"
			/>

			<vs-checkbox v-model="warning" class="mx-0 my-3">
				{{ $t("warning") }}
			</vs-checkbox>

			<div class="form-input">
				<vs-input
					v-if="!warning"
					v-model="amount"
					:label="$t('penaltySum')"
					class="amount-input"
					name="amount"
				/>

				<span
					v-if="this.amount > this.maxValue"
					class="text-danger text-sm"
				>
					{{ $t("maxValue", { n: maxValue }) }}
				</span>
			</div>

			<div class="form-input mx-0 my-3">
				<label class="vs-input--label">{{ $t('message') }}</label>
				<vs-textarea
					class="penalty-message p-2"
					v-model="message"
					:placeholder="$t('writeMessage')"
				/>
			</div>
		</div>

		<div v-if="orderId && authorPrice.length > 0" class="mt-2">
			<label class="vs-input--label">Author price by milestones</label>
			<ul class="pl-2">
				<li v-for="(milestonePrice, index) in authorPrice"> Stage {{ index + 1 }} - {{ milestonePrice === 'No data' ? milestonePrice : milestonePrice + ' EUR' }}</li>
			</ul>
		</div>

		<div class="set-ticket-failed__controls">
			<vs-button
				:disabled="!reason || !orderId || !message || disableSubmit"
				class="mr-1"
				color="primary"
				@click="confirm"
			>
				{{ $t("save") }}
			</vs-button>

			<vs-custom-button @click="close" color="#9a9a9a" type="flat">
				{{ $t("cancel") }}
			</vs-custom-button>
		</div>
	</vs-popup>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import vSelect from "vue-select";

export default {
	name: "PenaltyPopup",
	mixins: [databaseManager],
	props: {
		active: { default: false, type: Boolean },
		recommendedPrice: { default: 0 },
		maxValue: { type: Number },
		authorId: { default: null }
	},

	components: {
		vSelect,
	},

	data() {
		return {
			reason: null,
			penaltyReasons: [],
			authorPrice: [],
			amount: 0,
			orderId: null,
			message: null,
			warning: false,
			reasonCodeMap: {
				1: 'Lateness',
				2: 'Plagirism',
				3: 'ViolationOfAWS',
				4: 'ViolationOfTOR',
				5: 'CancellationInProgress',
				6: 'UsageOfAI',
				7: 'MistakesInTheDesignOfTheWork',
				8: 'NoResponseToManager',
				9: 'NonComplianceWRevisionInstructions',
				10: 'Other',
			},
			selectMounted: false,
		};


	},
	watch: {
		activeProp(newValue) {
			if (newValue === false) {
				this.reason = null;
				this.amount = 0;
				this.orderId = null;
				this.warning = false;
				this.selectMounted = false;
			} else {
				this.selectMounted = true;

				this.$nextTick(() => {
					setTimeout(() => {
						if (this.$refs.penaltySelect && this.$refs.penaltySelect.computeDropdownPosition) {
							this.$refs.penaltySelect.computeDropdownPosition();
						}
					}, 300);
				});
			}
		},
		orderId(newValue) {
			if (newValue) {
				this.authorPrice = [];
				this.refreshAuthorPrice();
			}
		},
		reason() {
			this.autoFillMessage();
		},
		warning() {
			this.autoFillMessage();
		}
	},
	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		},

		disableSubmit() {
			if (!this.maxValue) {
				return false;
			}
			if (!this.warning && Number(this.amount) === 0) {
				return true;
			}

			return this.amount > this.maxValue;
		},
	},
	methods: {
		async fetchPenaltyTemplate() {
			if (!this.reason) {
				this.message = '';
				return;
			}
			try {
				const url = `admin/author/penalty-message/${this.reason}`;
				const response = await this.$http.get(url, {
					params: {
						warning: this.warning ? 'true' : 'false'
					}
				});
				this.message = response.data.data.message || '';
			} catch (e) {
				this.message = '';
				console.error('Error fetching penalty template:', e);
			}
		},
		autoFillMessage() {
			const codeKey = this.reasonCodeMap[this.reason];

			if (!codeKey) {
				this.message = '';
				return;
			}

			const code = this.warning ? `warning${codeKey}` : `penalty${codeKey}`;

			this.fetchPenaltyTemplate(code, this.orderId || 'XXX', this.amount || 'XX');
		},
		confirm() {
			if (this.reason === null) return;
			const amount = this.warning ? null : this.amount;
			this.$emit("confirm", {
				reason: this.reason,
				orderId: this.orderId,
				message: this.message,
				warning: this.warning ? 'true' : 'false',
				amount,
			});
			this.activeProp = false;
		},
		close() {
			this.activeProp = false;
		},
		async refreshAuthorPrice() {
			this.authorPrice = await this.dbGetAuthorPrice(this.orderId, this.authorId);
		},
	},
	async mounted() {
		this.penaltyReasons = await this.dbGetPenaltyReasons();
	}
};
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.set-ticket-failed {
	&__title {
		padding-left: 8px;
		padding-right: 8px;
	}

	&__list {
		padding-left: 8px;
		padding-right: 8px;
		margin-top: 7px;
	}

	&__item {
		margin-top: 5px;
	}

	&__controls {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.vs-popup {
		max-width: 450px !important;
		width: 100% !important;
		padding: 0;

		&--content {
			width: 100%;
			height: 100%;
		}

		&--close,
		&--title h3 {
			color: $primary;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
		.vs-textarea {
			height: 10rem;
		}
	}
	.amount-input {
		width: 100%;
	}
	.vs__dropdown-menu {
		width: 100% !important;
		min-width: 100% !important;
		box-sizing: border-box;
	}
}
</style>
